<template>
     <div class="sessionBox sessionTwoBox">
            <div class="session">
                <div class="centerTitle">媒体中心</div>
                <div class="mediaBox">
                    <div class="mediaLeft">
                        <div class="clearfix changeT">
                            <div class="mediaTab fl">
                                <div :class="type==1?'active fontw':''" @click="changType(1)">企业动态</div>
                                <div :class="type==2?'active fontw':''" @click="changType(2)">行业资讯</div>
                            </div>
                            <div class="more fr" @click="jumpTo('/mediaCenter/companyNews',type)">更多&gt;</div>
                        </div>
                        <div class="newsBox" v-if="type==1">
                            <div v-for="(item,index) in companyNewsList" :key="index">
                                <div class="clearfix" v-if="index==0 && item.picture && item.picture != 'None'" style="margin-bottom:30px;margin-top:12px">
                                    <img class="fl mediaImg" :src="item.picture" alt="">
                                    <div class="fr mediaCont">
                                        <p class="overh2 c33 curp biaot" @click="jumpToDetails(item, '/mediaCenter/CompanyNewsDetails')">{{item.title}}</p>
                                        <p class="textr">{{String(item.addTime).slice(0, 10)}}</p>
                                    </div>
                                </div>
                                <div class="clearfix" v-else>
                                    <p class="fl overh ptitle biaot" @click="jumpToDetails(item, '/mediaCenter/CompanyNewsDetails')">{{item.title}}</p>
                                    <span class="fr">{{String(item.addTime).slice(0, 10)}}</span>
                                </div>
                            </div>
                            <el-empty v-if="!companyLoading && companyNewsList.length==0" description="暂无数据"></el-empty>
                        </div>
                        <div class="newsBox" v-if="type==2">
                            <div v-for="(item,index) in industryNewsList" :key="index+'ss'">
                                <div class="clearfix" v-if="index==0 && item.picture && item.picture != 'None'" style="margin-bottom:30px;margin-top:12px">
                                    <img class="fl mediaImg" :src="item.picture" alt="">
                                    <div class="fr mediaCont">
                                        <p class="overh2 c33 curp biaot" @click="jumpToDetails(item, '/mediaCenter/CompanyNewsDetails')">{{item.title}}</p>
                                        <p class="textr">{{String(item.addTime).slice(0, 10)}}</p>
                                    </div>
                                </div>
                                <div class="clearfix" v-else>
                                    <p class="fl overh ptitle biaot" @click="jumpToDetails(item, '/mediaCenter/industryNewsDetails')">{{item.title}}</p>
                                <span class="fr">{{String(item.addTime).slice(0, 10)}}</span>
                                </div>
                            </div>
                            <el-empty v-if="!industryLoading && industryNewsList.length==0" description="暂无数据"></el-empty>
                        </div>
                    </div>
                    <div class="mediaRight">
                        <div class="clearfix changeT">
                            <div class="mediaTabs fl">
                                <div :class="leix==1?'active fontw':''" @click="changLeix(1)">公告</div>
                                <div :class="leix==2?'active fontw':''" @click="changLeix(2)">公示</div>
                                <div :class="leix==3?'active fontw':''" @click="changLeix(3)">澄清与修改</div>
                                <div :class="leix==4?'active fontw':''" @click="changLeix(4)" style="margin-right:0">公众参与公示</div>
                            </div>
                            <div class="more fr" v-if="leix==1" @click="jumpTo('/mediaCenter/Notice')">更多&gt;</div>
                            <div class="more fr" v-if="leix==2" @click="jumpTo('/mediaCenter/Public')">更多&gt;</div>
                            <div class="more fr" v-if="leix==3" @click="jumpTo('/mediaCenter/Clarify')">更多&gt;</div>
                            <div class="more fr" v-if="leix==4" @click="jumpTo('/mediaCenter/NoticePub')">更多&gt;</div>
                        </div>
                        <div class="newsBox" v-if="leix==1">
                            <div class="clearfix" v-for="(item,index) in noticeList" :key="index">
                                <p class="fl overh biaot" @click="jumpToDetails(item, '/mediaCenter/NoticeDetails')">{{item.title}}</p>
                                <span class="fr">{{String(item.addTime).slice(0, 10)}}</span>
                            </div>
                            <el-empty v-if="!noticeLoading && noticeList.length==0" description="暂无数据"></el-empty>
                        </div>
                        <div class="newsBox" v-if="leix==2">
                            <div class="clearfix" v-for="(item,index) in noticeList" :key="index">
                                <p class="fl overh biaot" @click="jumpToDetails(item, '/mediaCenter/PublicDetails')">{{item.title}}</p>
                                <span class="fr">{{String(item.addTime).slice(0, 10)}}</span>
                            </div>
                            <el-empty v-if="!noticeLoading && noticeList.length==0" description="暂无数据"></el-empty>
                        </div>
                        <div class="newsBox" v-if="leix==3">
                            <div class="clearfix" v-for="(item,index) in noticeList" :key="index">
                                <p class="fl overh biaot" @click="jumpToDetails(item, '/mediaCenter/ClarifyDetails')">{{item.title}}</p>
                                <span class="fr">{{String(item.addTime).slice(0, 10)}}</span>
                            </div>
                            <el-empty v-if="!noticeLoading && noticeList.length==0" description="暂无数据"></el-empty>
                        </div>
                        <div class="newsBox" v-if="leix==4">
                            <div class="clearfix" v-for="(item,index) in noticeList" :key="index">
                                <p class="fl overh biaot" @click="jumpToDetails(item, '/mediaCenter/NoticePubDetails')">{{item.title}}</p>
                                <span class="fr">{{String(item.addTime).slice(0, 10)}}</span>
                            </div>
                            <el-empty v-if="!noticeLoading && noticeList.length==0" description="暂无数据"></el-empty>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>

    const NEW_API_BASE = process.env.VUE_APP_NEW_API_URL || '/prod-api'
const newApi = (path) => NEW_API_BASE + path
export default{
        data(){
            return{
                type:1,
                leix:1,
                companyNewsList: [], //企业动态
                industryNewsList:[], //行业资讯
                webcode:'100136102',
                noticeList:[],
                companyLoading: true,
                industryLoading: true,
                noticeLoading: true
            }
        },
        methods:{
            jumpTo(path,type){
                if(type==1){
                    window.location.assign('/mediaCenter/companyNews')
                }else if(type==2){
                    window.location.assign('/mediaCenter/IndustryNews')
                }else{
                    window.location.assign(path)
                }
            },
            // 列表项跳转：有外链则新窗口打开，否则跳站内详情页
            jumpToDetails(item, detailPath){
                if(item.webUrl){
                    const url = /^https?:\/\//i.test(item.webUrl) ? item.webUrl : 'http://' + item.webUrl
                    window.open(url, '_blank')
                }else{
                    this.$router.push({ path: detailPath, query: { id: item.id } })
                }
            },
             //切换企业和行业资讯
             changType(type){
                this.type=type
                if(type==1){
                    this.getCompanyNews()
                }
                if(type==2){
                    this.getIndustryNews()
                }
            },
            //切换公告 公示 澄清与修改
            changLeix(type){
                this.leix= type
                var codeList=['100136102','100136103','100136104','100145']
                this.webcode= codeList[type-1]
                this.noticeList=[]
                this.noticeLoading = true
                this.getNotice()
            },

            //获取企业动态列表
            getCompanyNews(){
                this.companyLoading = true
                this.Request({
                    url: newApi('/hzfglSys/news/public/newsList'),
                    baseURL: '',
                    method: 'get',
                    data:{
                        pagesize:8,
                        webcode:'web_100100',
                        years:3
                    }
                }).then((res) => {
                    var data = res.data;
                    if(data && data.rows && data.rows.length > 0){
                        this.companyNewsList = data.rows
                    }
                }).finally(() => {
                    this.companyLoading = false
                })
            },
            //获取行业资讯列表
            getIndustryNews(){
                this.industryLoading = true
                this.Request({
                    url: newApi('/hzfglSys/news/public/newsList'),
                    baseURL: '',
                    method: 'get',
                    data:{
                        pagesize:8,
                        webcode:'web_100101',
                        years:3
                    }
                }).then((res) => {
                    var data = res.data;
                    if(data && data.rows && data.rows.length > 0){
                        this.industryNewsList = data.rows
                    }
                }).finally(() => {
                    this.industryLoading = false
                })
            },

            //获取公告/公示接口
            getNotice(){
                this.noticeLoading = true
                this.Request({
                    url: newApi('/hzfglSys/news/public/newsList'),
                    baseURL: '',
                    method: 'get',
                    data:{
                        pagesize:11,
                        webcode:'web_'+this.webcode,
                        years:5
                    }
                }).then((res) => {
                    var data = res.data;
                    if(data && data.rows && data.rows.length > 0){
                        this.noticeList = data.rows
                    }
                }).finally(() => {
                    this.noticeLoading = false
                })
            },
        },
        mounted(){
            this.getCompanyNews()
            this.getNotice()
        }
    }
</script>

<style lang="less" scoped>
    .sessionTwoBox{
        height: 767px;
        background-image: url('../../../assets/index/mediaBg.png');
        background-size: cover;
        background-position: center;
        margin-top: 60px;
    }
    .sessionBox {
        display: flex;
        justify-content: center;
    }
    .session {
        width: 1200px;
    }
    .centerTitle {
        text-align: center;
        margin-top: 68px;
        font-size: 36px;
        color: #333333;
    }
    .mediaBox{
       display: flex;
       justify-content: space-between;
       margin-top: 70px;
    }
    .mediaLeft{
        width: 700px;
        height: 530px;
        background-color: #fff;
        border-radius: 10px;
    }
    .mediaRight{
        width: 484px;
        height: 530px;
        background-color: #fff;
        border-radius: 10px;
    }
    .mediaImg{
        width: 184px;
        height: 111px;
    }
    .mediaCont{
        width: 416px;
        margin-top: 20px;
        line-height: 30px;
    }
    .mediaCont p:first-child{
        font-size: 16px;
        font-weight: 400;
    }
   
    .changeT{
        border-bottom: 1px solid #F1F1F1;
    }
    .mediaTab,.mediaTabs{
        display: flex;
        justify-content: flex-start;
        height: 65px;
        line-height: 65px;
        padding: 0 36px;
    }
    .mediaTab div{
        margin-right: 20px;
        padding: 0 8px;
        cursor: pointer;
    }
    .mediaTabs div{
        padding: 0 8px;
        cursor: pointer;
    }
    .mediaTab div:hover , .mediaTabs div:hover{
        color: #247CD6;
    }
    .active{
        color: #0072C6;
        border-bottom: 2px solid #0072C6;
    }
    .newsBox{
        padding: 15px 36px;
        line-height: 38px;
        color: #666;
        font-size: 14px;
    }
    .mediaLeft .newsBox .ptitle{
        width: 510px;
        cursor: pointer;
        font-size: 14px;
    }
    .mediaRight .newsBox p{
        width: 317px;
        cursor: pointer;
    }
    .more{
        text-align: center;
        color: #999;
        cursor: pointer;
        font-size: 14px;
        line-height: 65px;
        margin-right: 36px;
    }
    .more:hover{
        color: #247CD6;
    }
    .biaot:hover{
        color: #247CD6;
    }
</style>